import React, { useEffect, useState } from "react";
import styles from "./EditCategory.module.css";
import step from "../../../assets/step1.png";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../../components/input/InputField";
import { Radio } from "antd";
import Button from "../../../components/button/Button";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CategoriesMiddleware from "../../../store/Middlewares/CategoriesMiddleware";
import { useDispatch, useSelector } from "react-redux";

function EditCategory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value, setValue] = useState(1);
  const { t, i18n } = useTranslation();
  const { state } = useLocation();
  const data = state;
  console.log("data", data);

  const category = useSelector((state) => state.CategoriesReducer.CategoryList);
  console.log("category", category);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  useEffect(() => {
    getCategories();
  }, []);
  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories());
  };

  return (
    <div className={styles.home_mainContainer}>
      <div className={styles.flex}>
        <h1 className={styles.heading}>{t("Edit Job Details")}</h1>
        <img src={step} className={styles.step_image} />
      </div>

      <div className={styles.radio_view}>
        <text className={styles.sub_heading}>{t("Category")}</text>
        <Radio.Group
          disabled
          className={styles.radio_sub_view}
          name="radiogroup"
          value={data?.category_name}
        >
          {category?.map((item) => {
            console.log("item", item);
            return (
              <Radio className={styles.radio_title} value={item?.name}>
                {item?.name}
              </Radio>
            );
          })}
        </Radio.Group>
      </div>
      {/* <div className={styles.radio_view}>
        <text className={styles.sub_heading}>{t("Category")}</text>
        <Radio.Group
          disabled
          className={styles.radio_sub_view}
          name="radiogroup"
          value={data?.category_name}
        >
          <Radio className={styles.radio_title} value={"Custodial Engineer"}>
            {t("Custodial Engineer")}
          </Radio>
          <Radio className={styles.radio_title} value={"Flooring"}>
            {t("This Week")}
          </Radio>
          <Radio className={styles.radio_title} value={"One Day"}>
            {t("One Day")}
          </Radio>
          <Radio className={styles.radio_title} value={"When Possible"}>
            {t("When Possible")}
          </Radio>
        </Radio.Group>
      </div> */}

      <InputField
        label={t("Date")}
        value={moment(data?.date).format("MM-DD-YYYY")}
        rightIcon={true}
        disabled={true}
      />

      <InputField
        label={t("Customer")}
        value={data?.customer_name}
        disabled={true}
        textCenter={true}
      />

      <InputField
        label={t("Location")}
        value={data?.location?.address}
        disabled={true}
      />

      <div className={styles.radio_view}>
        <text className={styles.sub_heading}>{t("Urgency")}</text>
        <Radio.Group
          disabled
          className={styles.radio_sub_view}
          name="radiogroup"
          value={data?.urgency}
        >
          <Radio className={styles.radio_title} value={"Emergency"}>
            {t("Emergency")}
          </Radio>
          <Radio className={styles.radio_title} value={"This Week"}>
            {t("This Week")}
          </Radio>
          <Radio className={styles.radio_title} value={"One Day"}>
            {t("One Day")}
          </Radio>
          <Radio className={styles.radio_title} value={"When Possible"}>
            {t("When Possible")}
          </Radio>
        </Radio.Group>
      </div>

      <div className={styles.button}>
        <Button
          text={t("Next")}
          onClick={() =>
            navigate("/WorkOrderRequest/JobDetails", { state: data })
          }
        />
      </div>
    </div>
  );
}

export default EditCategory;
